<template>
    <div class="row g-0 login-container">
        <!-- Left Side (Form) -->
        <div class="col-lg-6 d-flex flex-column justify-content-center p-5 position-relative bg-white z-2">
            <div class="w-100 mx-auto" style="max-width: 450px;">
                <h1 class="text-brown fw-bold font-serif mb-5">Create a New Account</h1>

                <form @submit.prevent="submitRegister">
                    <div class="mb-3">
                        <input type="text" class="form-control rounded-3 py-2" v-model="name" placeholder="Enter your name" required :class="{ 'is-invalid': errors.name }">
                        <div class="invalid-feedback" v-if="errors.name">
                            {{ errors.name[0] }}
                        </div>
                    </div>
                    <div class="mb-3">
                        <input type="email" class="form-control rounded-3 py-2" v-model="email" placeholder="Enter your email" required :class="{ 'is-invalid': errors.email }">
                        <div class="invalid-feedback" v-if="errors.email">
                            {{ errors.email[0] }}
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="input-group" :class="{ 'is-invalid': errors.phone }">
                            <span class="input-group-text bg-light border-end-0 text-muted border-light-subtle">+2</span>
                            <input type="text" class="form-control rounded-end-3 py-2 border-start-0" v-model="phone" placeholder="Enter your phone" :class="{ 'is-invalid': errors.phone }">
                        </div>
                        <div class="invalid-feedback" v-if="errors.phone">
                            {{ errors.phone[0] }}
                        </div>
                    </div>
                    <div class="mb-5 position-relative">
                        <input :type="passwordVisible ? 'text' : 'password'" class="form-control rounded-3 py-2" v-model="password" placeholder="Enter your password" required :class="{ 'is-invalid': errors.password }">
                        <i class="bi position-absolute top-50 end-0 translate-middle-y me-3 text-muted cursor-pointer" 
                           :class="passwordVisible ? 'bi-eye-slash' : 'bi-eye'"
                           @click="passwordVisible = !passwordVisible"></i>
                        <div class="invalid-feedback" v-if="errors.password">
                            {{ errors.password[0] }}
                        </div>
                    </div>

                    <button type="submit" class="btn btn-brown w-100 py-2 rounded-2 mb-4" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <span v-else>Sign up</span>
                    </button>

                    <div class="text-center small text-brown fw-bold">
                        I have an account <a href="/customer/login" class="text-brown text-decoration-none">log in</a>
                    </div>
                    
                    <div v-if="generalError" class="alert alert-danger mt-3 small">
                        {{ generalError }}
                    </div>
                </form>
            </div>

            <div class="position-absolute bottom-0 start-0 w-100 text-muted xx-small text-center pb-4">
                All rights reserved to FIT..... 2025©
            </div>
        </div>

        <!-- Right Side (Visual) -->
        <div
            class="col-lg-6 position-relative d-none d-lg-block split-bg-right d-flex align-items-center justify-content-center overflow-hidden">
            <!-- Angled Divider -->
            <div
                style="position: absolute; top:0; left:0; width: 100%; height: 100%; background-color: transparent; pointer-events: none;">
                <div
                    style="position: absolute; top:0; left: -100px; width: 15vw; height: 100%; background: white; transform: skewX(-15deg); transform-origin: top;">
                </div>
            </div>

            <div class="position-relative text-center z-1 w-75">
                <div class="mb-5">
                    <h1 class="display-3 fw-bold text-brown font-serif">FR<br><span
                            class="h6 fw-normal inter-font letter-spacing-2">FEKRA</span></h1>
                </div>

                <div class="arch-image-container position-relative shadow-lg">
                    <img src="https://placehold.co/400x500/8D6E63/white?text=Living+Room"
                        class="w-100 h-100 object-fit-cover" alt="Interior">
                </div>

                <!-- Decorative +s -->
                <div class="position-absolute top-0 end-0 text-brown small lh-1 opacity-50 pe-4 mt-5">
                    + +<br>+ +<br>+ +
                </div>
                <div class="position-absolute bottom-0 start-0 text-brown small lh-1 opacity-50 ps-4 mb-5">
                    + +<br>+ +<br>+ +
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                name: '',
                email: '',
                phone: '',
                password: '',
                passwordVisible: false,
                loading: false,
                errors: {},
                generalError: ''
            }
        },
        mounted() {
            console.log('Register Component mounted.')
        },
        methods: {
            submitRegister() {
                this.loading = true;
                this.errors = {};
                this.generalError = '';

                axios.post('/customer/register-submit', {
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    password: this.password
                })
                .then(response => {
                    window.location.href = response.data.redirect || '/';
                })
                .catch(error => {
                    this.loading = false;
                    if (error.response && error.response.status === 422) {
                        this.errors = error.response.data.errors;
                    } else if (error.response && error.response.data && error.response.data.message) {
                        this.generalError = error.response.data.message;
                    } else {
                        this.generalError = 'An error occurred. Please try again.';
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .split-bg-right {
        background-image: url('https://placehold.co/1920x1080/F9F5F0/F9F5F0?text=Wood+Texture');
        background-size: cover;
        background-position: center;
        position: relative;
    }

    .login-container {
        min-height: 100vh;
        overflow: hidden;
    }

    .arch-image-container {
        border-top-left-radius: 50% 20%;
        border-top-right-radius: 50% 20%;
        overflow: hidden;
        height: 400px;
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
    }
</style>
